<template>
    <el-menu class="navbar" mode="horizontal">
        <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        <levelbar></levelbar>
        <!-- <tabs-view></tabs-view> -->
        <div class="nav-info" v-if='navbarData.storetotal'>门店：{{navbarData.storetotal}}</div>
        <div class="nav-info" v-if='navbarData.agenttotal'>合作商：{{navbarData.agenttotal}}</div>
        <screenfull class='screenfull'></screenfull>
        <el-dropdown class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
                <img class="user-avatar" :src="photoUrl">
                <i class="el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu class="user-dropdown" slot="dropdown">
                <!-- <router-link class='inlineBlock' to="/  ">
                        <el-dropdown-item>
                            合作商
                        </el-dropdown-item>
                    </router-link> -->
                <el-dropdown-item divided v-if="user_title">
                    <span style="display:block;">{{user_title}}</span>
                </el-dropdown-item>
                <el-dropdown-item divided v-if="islocal_user===true">
                    <span @click="changePSW" style="display:block;">修改密码</span>
                </el-dropdown-item>
                <el-dropdown-item divided >
                    <span @click="runLogout" style="display:block;">退出</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <!--修改密码-->
        <div class="pass">
            <el-dialog title="修改密码" v-model="showDialog" style="width:100%">
                <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="密码" prop="pass">
                        <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass">
                        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm2')">提交</el-button>
                        <el-button @click="resetForm('ruleForm2')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'   //获取vuex数据
import Levelbar from './Levelbar'   //面包屑导航
import Hamburger from '@/components/Hamburger'  //隐藏侧边栏
import TabsView from './TabsView'   //历史打开页面保存
import Screenfull from '@/components/Screenfull'    //全屏

// 请求参数设置
import base from '@/base.js';
import EnvBase from '@/env.js'
import SvrApi from '@/svrapi.js'
var PT = EnvBase.PT;

export default {
    components: {
        Levelbar,
        Hamburger,
        Screenfull,
        TabsView
    },
    data: function() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm2.checkPass !== '') {
                    this.$refs.ruleForm2.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm2.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            user_title: "",
            photoUrl: "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80",
            showDialog: false,
            ruleForm2: {
                pass: '',
                checkPass: '',
            },
            rules2: {
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
            }
        }
    },
    mounted: function() {
        var self = this;
        eventBus.$on('user_title', function(val) {
            self.user_title = val;
        })
    },
    computed: {
        ...mapGetters([
            'sidebar',
            'avatar',
            'navbarData',
            'permissions'
        ]),
        islocal_user() {
            return Array.isArray(this.permissions) && this.permissions.includes('local_user_base_module');
        }
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch('ToggleSideBar')
        },
        handleOnLogout(rsp) {
            window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
        },
        // 退出登录
        runLogout() {
            var postParams = {
                local_sess: PT.qnlogin.getLocalSess(),
            }
            PT.apiClient.query(SvrApi.logout, postParams, this.handleOnLogout);
            PT.qnlogin.logout();

            this.hasLogin = PT.qnlogin.isLocalSessOk;
            localStorage.removeItem("user_all")
            localStorage.removeItem("user_data")
        },
        submitForm(formName) {
            var self = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var userType = self.$store.state.user.user_type;
                    if (userType === 'agent_staff') {
                        // 员工修改密码
                        var data = {
                            guid: self.$store.state.user.guid,
                            new_pwd: self.ruleForm2.pass
                        }
                        PT.apiClient.query(SvrApi.modifyPass, data, function(rsp) {
                            if (rsp.code == 0) {
                                self.$alert("密码修改成功", '提示');
                                self.runLogout();
                            } else {
                                self.$alert(rsp.msg, '提示');
                            }
                        });
                    } else {
                        // 老板修改密码
                        var data = {
                            guid: 1,
                            new_pwd: self.ruleForm2.pass,
                            repeat_new_pwd: self.ruleForm2.checkPass
                        }
                        PT.apiClient.query(SvrApi.Modifypassword, data, function(rsp) {
                            if (rsp.code == 0) {
                                self.$alert("密码修改成功", '提示');
                                self.runLogout();
                            } else {
                                self.$alert(rsp.msg, '提示');
                            }
                        });
                    }
                } else {
                    alert('error submit!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changePSW() {
            this.showDialog = true;
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    .hamburger-container {
        line-height: 58px;
        height: 50px;
        float: left;
        padding: 0 10px;
    }
    .errLog-container {
        display: inline-block;
        position: absolute;
        right: 150px;
    }
    .screenfull {
        position: absolute;
        right: 90px;
        top: 16px;
        color: red;
    }
    .avatar-container {
        height: 50px;
        display: inline-block;
        position: absolute;
        right: 35px;
        .avatar-wrapper {
            cursor: pointer;
            margin-top: 5px;
            position: relative;
            .user-avatar {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 25px;
                font-size: 12px;
            }
        }
    }
    .nav-info {
        position: absolute;
        right: 140px;
        top: 0;
        font-size: 18px;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/Navbar.vue?728e6dce